import styled from "styled-components";

const Control = styled.button.attrs(() => ({
    className: "cmp-control",
}))``;

export default Control;
